import React, {Component} from 'react';
import TransactionBasket from './TransactionBasket';

class TransactionList extends Component {
	render() {
		return (
			<div className="list-transactions">
				<div className="row transactions-header">
					<div className="col-xs-12 col-sm-3 basket-labels">
						Purchase Date
					</div>
					<div className="col-xs-12 col-sm-9 basket-labels">
						Items
					</div>
					<div className="col-xs-12">
						<hr/>
					</div>
				</div>
				{
					this.props.transactionHistory.map((item, id) => {
						return <TransactionBasket
							key={id}
							transaction_id={item.id}
							price={item.basket.price}
							items={item.basket.transaction_items}
							date={item.created_at}
							currency={item.basket.currency}
						/>
					})
				}
			</div>
		)
	}
}

export default TransactionList;


// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/TransactionList.js